import { render, staticRenderFns } from "./InternalOrdersList.vue?vue&type=template&id=e22811c4&scoped=true"
import script from "./InternalOrdersList.vue?vue&type=script&lang=js"
export * from "./InternalOrdersList.vue?vue&type=script&lang=js"
import style0 from "./InternalOrdersList.vue?vue&type=style&index=0&id=e22811c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22811c4",
  null
  
)

export default component.exports